var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoneycardSmall = function SvgMoneycardSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 14.5,
    x: 0.75,
    y: 0.75,
    fill: "#fff",
    rx: 2.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 14.5,
    x: 0.75,
    y: 0.75,
    stroke: "#F36805",
    strokeWidth: 1.5,
    rx: 2.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F36805",
    d: "M19.687 12 1.313 10.606V.333h18.375z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#moneycardSmall_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.386 2.73s.19-.142.406 0c0 0 .49.307.899.658 0 0 .077.054.08-.039 0 0-.013-.273.02-.36 0 0 .037-.113.15-.11 0 0 .35.019.576.05 0 0 .156.016.183.2 0 0 .144.974.173 1.325 0 0 .028.179.283.481 0 0 .515.733.579.877 0 0 .121.255-.138.289 0 0-.474.048-.519.056 0 0-.11.005-.106.134 0 0-.025 1.692-.147 2.506 0 0-.032.323-.208.315 0 0-.487-.016-.6-.013 0 0-.049.004-.041-.066 0 0 .247-2.64.08-3.976 0 0-.007-.172-.138-.208 0 0-.116-.048-.231.11 0 0-.771.992-.77 2.38 0 0-.014.422.05.53 0 0 .038.074.24.09l.255.035s.048.002.043.063c0 0-.057.776-.074.912 0 0-.003.062-.02.092 0 0-.01.026-.09.023 0 0-1.123-.008-1.25-.002 0 0-.053.005-.064-.028-.011-.032-.079-1-.076-1.138 0 0-.004-.049.04-.068a.68.68 0 0 0 .311-.502s.017-.08.007-.443c0 0 .04-1.486.051-1.724 0 0 .01-.08-.095-.096 0 0-.101-.02-.117.081 0 0-.073.98-.058 1.37 0 0 .025.254-.148.259 0 0-.169.026-.177-.185 0 0 .012-.954.053-1.424 0 0 .007-.083-.092-.102 0 0-.101-.02-.12.094 0 0-.073.911-.057 1.392 0 0 .021.234-.163.225 0 0-.153.019-.162-.189 0 0 .042-1.304.053-1.406 0 0 .01-.107-.1-.116 0 0-.1-.014-.113.096 0 0-.068 1.56-.057 2.018 0 0-.006.471.337.663 0 0 .05.029.052.074 0 0 .039.828.074 1.094 0 0 .013.064-.044.065l-.864.023s-.143.01-.174-.17c-.029-.167-.187-1.55-.161-2.643 0 0 .01-.125-.105-.144 0 0-.443-.041-.55-.069 0 0-.205-.059-.112-.274 0 0 .96-1.838 2.946-3.085",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "moneycardSmall_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.219 2.667h6.563v6.667H7.219z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoneycardSmall);
export default ForwardRef;